import { BaseOapStatus } from '@/classes/SubmissionStatuses/BaseOapStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { toTitleCase } from '@/classes/SubmissionStatuses/statusUtils'

export class SuccessStatus extends BaseOapStatus {
	getToolTipText() {
		return {
			title: this.getVendorName() + ' Submission Successful',
			body: `This packet submitted successfully to (${toTitleCase(this.submissionStatus.provider)}).`,
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.SUCCESS
	}
}
